import { useQuery } from '@tanstack/react-query';
import { getCanaryUserFeatures } from 'api/services/feature-rollout.service';
import { useCallback } from 'react';

export function useFeatureRolloutData() {
    const query = useQuery({ queryKey: ['featureRollouts'], queryFn: () => getCanaryUserFeatures() });

    const hasFeature = useCallback(
        (name: string) => {
            const featureRollouts = query.data || [];

            if (featureRollouts.length === 0) return false;

            const feature = featureRollouts.find((feature) => feature.name === name);

            return Boolean(feature);
        },
        [query.data]
    );

    return {
        hasFeature: hasFeature,
    };
}
